import { navigateTab, openBlankTab } from '@/lib/new-tab'

/* stripe-named wrappers over the shared helper: a stripe url only arrives
 * after an await, which ios treats as a popup and blocks. */
export function openStripeTab(): Window | null {
  return openBlankTab()
}

export function goToStripe(url: string, tab?: Window | null): void {
  navigateTab(url, tab)
}
